module.exports = __webpack_public_path__ + "static/media/seriesImportTemp.ec6b81e1.xlsx";